import React from "react";
import { Box, Typography, Button, Container, Paper } from "@mui/material";
import { Lock, ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

interface UnauthorizedAccessProps {
  title?: string;
  description?: string;
  onGoBack?: () => void;
}

/**
 * Componente que se muestra cuando el usuario no tiene permisos para acceder a una sección
 */
export const UnauthorizedAccess: React.FC<UnauthorizedAccessProps> = ({
  title = "Acceso Denegado",
  description = "No tienes permisos para acceder a este recurso. Contacta con el administrador si consideras que esto es un error.",
  onGoBack,
}) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (onGoBack) {
      onGoBack();
    } else {
      navigate("/admin-dashboard");
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "400px",
          py: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            borderRadius: 2,
            backgroundColor: "#F9FAFB",
          }}
        >
          <Box
            sx={{
              mb: 2,
              p: 2,
              borderRadius: "50%",
              backgroundColor: "#FEE2E2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Lock sx={{ fontSize: 40, color: "#DC2626" }} />
          </Box>

          <Typography
            variant="h5"
            component="h1"
            sx={{
              mb: 1,
              fontWeight: 600,
              color: "#111827",
            }}
          >
            {title}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 3,
              color: "#6B7280",
              lineHeight: 1.6,
            }}
          >
            {description}
          </Typography>

          <Button
            variant="contained"
            color="primary"
            startIcon={<ArrowBack />}
            onClick={handleGoBack}
            sx={{
              textTransform: "none",
              fontSize: "1rem",
              px: 3,
              backgroundColor: "#10B981",
              "&:hover": {
                backgroundColor: "#059669",
              },
            }}
          >
            Volver al Inicio
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default UnauthorizedAccess;
